import { Dropdown, SelectOption } from "components/dropdown/Dropdown";
import { useField, useFormikContext } from "formik";
import { SetStateAction, useEffect, useState } from "react";
import {
  ParsedWorkflowItem,
  ReferenceData,
  WorkflowBuilderErrors,
  WorkflowReferenceDataNames,
} from "../WorkflowBuilderPage";
import { MultiDropdown } from "components/dropdown/MultiDropdown";
import _ from "lodash";
import { changeWorkflowBuilderReferenceData } from "./WorkflowItem";

import editIcon from "assets/edit_icon.png";

interface Props {
  fieldName: string;
  documentOptions: SelectOption[];
  projectOptions: SelectOption[];
  type: "trigger" | "action";
  triggerData: any;
  parsedData: ParsedWorkflowItem | null;
  setParsedData: React.Dispatch<SetStateAction<ParsedWorkflowItem | null>>;
  referenceData: ReferenceData | null;
  setReferenceData: React.Dispatch<SetStateAction<ReferenceData | null>>;
  showTriggerTypeSelector: boolean;
  setShowTriggerTypeSelector: React.Dispatch<SetStateAction<boolean>>;
  workflowBuilderErrors: WorkflowBuilderErrors;
}

export type EditNodeProps = {
  setShowSelector: React.Dispatch<SetStateAction<any>>;
};

export const EditNode: React.FC<EditNodeProps> = ({ setShowSelector }) => {
  return (
    <div className="EditNode" onClick={() => setShowSelector(true)}>
      <img src={editIcon} alt="Edit type" className="EditNodeIcon" />
    </div>
  );
};

const DocumentUploadTrigger: React.FC<Props> = ({
  fieldName,
  documentOptions,
  projectOptions,
  type,
  triggerData,
  parsedData,
  setParsedData,
  referenceData,
  setReferenceData,
  showTriggerTypeSelector,
  setShowTriggerTypeSelector,
  workflowBuilderErrors,
}) => {
  const [relevantErrors, setRelevantErrors] = useState<string[] | null>(null);

  useEffect(() => {
    if (
      workflowBuilderErrors &&
      workflowBuilderErrors.trigger &&
      workflowBuilderErrors.trigger.hasOwnProperty(0)
    ) {
      const tempErrors = workflowBuilderErrors.trigger[0];

      if (Array.isArray(tempErrors) && tempErrors.length > 0) {
        setRelevantErrors(tempErrors);
      } else {
        setRelevantErrors(null);
      }
    } else {
      setRelevantErrors(null);
    }
  }, [workflowBuilderErrors]);

  const handleChangeDocument = (option: SelectOption) => {
    if (parsedData) {
      let newParsedData: any = _.cloneDeep(parsedData);

      const newValue = option ? option.value : null;

      newParsedData.documentTypesID = newValue;

      setParsedData(newParsedData);

      let newReferenceData = _.cloneDeep(referenceData);

      if (newReferenceData?.trigger) {
        newReferenceData.trigger.documentTypesID = newValue;
      }

      setReferenceData(newReferenceData);
    }
  };

  const handleChangeProject = (options: SelectOption[]) => {
    if (parsedData) {
      let newParsedData: any = _.cloneDeep(parsedData);

      const newValue = options ? options.map(item => item.value) : null;

      newParsedData.projectTypesIDs = newValue;

      setParsedData(newParsedData);

      let newReferenceData = _.cloneDeep(referenceData);

      if (newReferenceData?.trigger) {
        newReferenceData.trigger.projectTypesIDs = newValue;
      }

      setReferenceData(newReferenceData);
    }
  };

  const handleSave = () => {};

  const title = "Document upload";
  return (
    <div
      className={`DocumentUploadTrigger TriggerContainer DetailsItemContent ${
        relevantErrors && relevantErrors.length > 0 ? "Error" : ""
      }`}
    >
      <label className="Title">
        <div className="Text">{`Trigger - ${title}`}</div>

        <EditNode setShowSelector={setShowTriggerTypeSelector} />
      </label>

      <div className="Row">
        <div className="Label">Document type</div>

        <Dropdown
          onChange={handleChangeDocument}
          value={
            triggerData && triggerData.documentTypesID
              ? documentOptions.find(
                  o => o.value === triggerData.documentTypesID
                )
              : null
          }
          options={documentOptions}
          placeholder="Please select"
          roundedRectangle
          portalMode={true}
          isClearable={true}
        />
      </div>

      <div className="Row">
        <div className="Label">
          Project type
          {/* <span className="Italic"> - opt</span> */}
        </div>

        <MultiDropdown
          customClassName="MultiDropdown"
          onChange={handleChangeProject}
          value={
            triggerData &&
            triggerData.projectTypesIDs &&
            Array.isArray(triggerData.projectTypesIDs)
              ? projectOptions.filter(o =>
                  triggerData.projectTypesIDs.includes(o.value)
                )
              : null
          }
          options={projectOptions}
          placeholder="Please select"
          isClearable={true}
          roundedRectangle
          portalMode={true}
        />
      </div>

      {relevantErrors && relevantErrors.length > 0 && (
        <div className="Errors">
          {relevantErrors.map(error => {
            return <div className="Error">{error}</div>;
          })}
        </div>
      )}

      {/* <button type="button" className="SaveBtn" onClick={handleSave}>
        Save
      </button> */}
    </div>
  );
};

export default DocumentUploadTrigger;
